<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-alert width="100%" class="pr-2 pl-2" v-if="saveErrorMessage" type="error"> {{ saveErrorMessage }}</v-alert>
            <v-data-table dense class="elevation-1"
                          :headers="headers"
                          :items="luItems"
                        
                          item-key="id"
                          :loading="isLoading"
                          :items-per-page="15">

                <template v-slot:[`item.id`]="{ item }">
                    {{ item.id}}

                </template>
                <template v-slot:[`item.description`]="{ item }">
                    {{ item.description}}

                </template>

                <template v-slot:top>
                    <v-toolbar flat>
                      
                        <v-dialog v-model="dialog"
                                  max-width="500px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-spacer></v-spacer>
                                <v-btn class="text-xs mb-2" v-on:click="reloadItems" color="primary">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>

                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5" v-if="editedIndex === -1">Add New Dog Type</span>
                                    <span v-else>Edit Dog Type: {{editedItem.id}}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-form v-model="isValid">
                                            <v-row>
                                                <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
                                            </v-row>
                                            <v-row v-if="editedIndex === -1">
                                                <v-col>

                                                    <v-text-field v-model="editedItem.id"
                                                                  label="Id*" :disabled="editedIndex != -1"
                                                                  :rules="[(v) => !!v || 'ID is required',(v) =>v.length <= 5 || 'Limited to 5 chars.', ]" />

                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.description" label="Description*"
                                                                  :rules="[(v) => !!v || 'Description is required',(v) =>v.length <= 50 || 'Limited to 50 chars.',]" />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <v-text-field v-model="editedItem.nextId" label="Next Id:" :disabled="true" />
                                                            </td>
                                                            <td>
                                                                <v-btn icon v-on:click="(e) => incrementId(editedItem)" color="primary">
                                                                    <v-icon>mdi-plus</v-icon>
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">
                                        Cancel
                                    </v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           :disabled="!isValid"
                                           @click="save">
                                        Add/Update
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                            <v-card>
                                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small
                            class="mr-2"
                            @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small v-if="item.canDelete"
                            @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>

            </v-data-table>

        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/admin/lookupsService";
import { DogTypeLookupInfo } from "@/types/admin/Lookup";

export default Vue.extend({
    name: "DogTypeMaintenance",
    data: function () {
        return {
            tab: null,
            luItems: [] as DogTypeLookupInfo[],
            tdialog: false,
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: "ID", align: "left", value: "id" },
                { text: "Description", align: "left", value: "description" },
                { text: "Next ID", align: "left", value: "nextId" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                id: "",
                description: "",
                nextId: 1,
                canDelete:true,
                
            },
            defaultItem: {
                id: "",
                description: "",
                nextId: 1,
                canDelete: true,

            },
            errorMessage: "",
            isValid: true,
            search: "",
            isLoading: false,
            saveErrorMessage:"",

        };
    },
    created: function () {
        this.reloadItems();

    },
    methods: {
        reloadItems: function () {
            this.$data.isLoading = true;
            lookupsService.getDogTypeInfo().then((res: DogTypeLookupInfo[]) => {
                this.luItems = res;
                this.$data.isLoading = false;
            });
        },
        editItem(item: DogTypeLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem(item: DogTypeLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            
            this.saveErrorMessage = "";
            if (!this.editedItem.canDelete) {
                this.closeDelete();
            }
            lookupsService.deleteDogType(this.editedItem.id).then((res) => {
                if (res.success == false) {
                    this.saveErrorMessage = res.messages.join(', ')

                }
                else {
                    this.luItems.splice(this.editedIndex, 1);
                }

                this.reloadItems(); //in case something was changed after that pull

            }).catch((e: any) => {
                this.saveErrorMessage = "Unable to delete the dog type.";
            });

            this.closeDelete();
        },

        close() {
            this.errorMessage = "";
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            this.errorMessage = "";
            if (this.editedItem.id.trim().length == 0 || this.editedItem.description.trim().length == 0) {
                this.errorMessage = "Please enter valid values."
                return;
            }
            if (!/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/i.test(this.editedItem.id)) {
                this.errorMessage = "Please enter valid values."
                return;
            }
            this.editedItem.id = this.editedItem.id.trim().toUpperCase();
            if (this.editedItem.id.includes(' ')) {
                this.errorMessage = "Please enter valid values."
                return;
            }

            if (this.luItems) {
                //kp note: we aren't allowing add right now but leaving this check in case they request it in the future
                if (this.editedIndex == -1) {
                    var exists = this.luItems.find((x: any) => x.id.toLowerCase() == this.editedItem.id.toLowerCase()
                        || x.description.toLowerCase() == this.editedItem.description.toLowerCase());
                    if (exists != null) {
                        this.errorMessage = "This Id or Description already exists.";
                        return;
                    }
                }
                else {
                    var exists = this.luItems.find((x: any) => x.description.toLowerCase() == this.editedItem.description.toLowerCase() && x.id != this.editedItem.id);
                    if (exists != null) {
                        this.errorMessage = "This Description already exists.";
                        return;
                    }
                }
            }
            lookupsService.editDogType(this.editedItem).then((res: any) => {
                if (res.success) {
                    if (this.editedIndex > -1) {
                        Object.assign(this.luItems[this.editedIndex], this.editedItem)

                    }
                    else {
                        if (this.luItems) {
                            this.luItems.unshift(this.editedItem);

                        }
                    }
                    this.close();
                }
                else {
                    this.errorMessage = "Unable to edit the dog type.";
                    return;
                }
            }).catch(
                () => {
                    this.errorMessage = "Unable to edit dog type.";
                });
            
        },
        incrementId(item: DogTypeLookupInfo) {
            item.nextId++;

        },
    },
    computed: {
        formTitle() {
            return this.$data.editedIndex === -1 ? "New Item" : "Edit Item";
        },
    },
    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },
    
});
</script>
